import { cookiesSlice } from '../reducers/cookies.reducers'

export const { setCookie } = cookiesSlice.actions
